// TagLibrary: Custom Elements Define Library, ES Module/ES5 Target
import { defineCustomElement } from './tag-library.core.js';
import {
  TagAccessLogo,
  TagAlert,
  TagAppHeader,
  TagAppHeaderOption,
  TagAvatar,
  TagBadge,
  TagBar,
  TagButton,
  TagCard,
  TagCardKpi,
  TagCardOkr,
  TagCardProfile,
  TagCarousel,
  TagCarouselSlide,
  TagChartGrid,
  TagCheckbox,
  TagCode,
  TagColour,
  TagColourOption,
  TagColourPicker,
  TagColumnPicker,
  TagCombobox,
  TagConfirm,
  TagDataBinder,
  TagDatePicker,
  TagEditField,
  TagEditFieldOption,
  TagEditList,
  TagField,
  TagFilePicker,
  TagForm,
  TagFormGroup,
  TagGraphQL,
  TagHttp,
  TagIcon,
  TagIconCustom,
  TagIconSvg,
  TagLayoutSidenav,
  TagLink,
  TagList,
  TagMainHeader,
  TagMenu,
  TagMenuItem,
  TagMessage,
  TagModal,
  TagModalOption,
  TagNav,
  TagNavSimple,
  TagNavSimpleGroup,
  TagNavSimpleItem,
  TagPager,
  TagPill,
  TagPills,
  TagPopover,
  TagProgressDonut,
  TagProgressIndeterminate,
  TagRecord,
  TagRecordNav,
  TagSearch,
  TagSearchbox,
  TagSlider,
  TagStat,
  TagStats,
  TagStatsData,
  TagSubmenu,
  TagTab,
  TagTabContent,
  TagTabHeader,
  TagTabHeaders,
  TagTable,
  TagTableColumn,
  TagTableColumnEditor,
  TagTabs,
  TagText,
  TagToast,
  TagToggle,
  TagTooltip,
  TagTopNavbar,
  TagValidation,
  TagValidationAlert,
  TagWizard,
  TagWizardStep,
  TagWizardVertical,
  TagWizardVerticalContent,
  TagWizardVerticalStep,
  TagWizardVerticalStepIndicator,
  TagWizardVerticalSteps
} from './tag-library.components.js';

export function defineCustomElements(window, opts) {
  defineCustomElement(window, [
    TagAccessLogo,
    TagAlert,
    TagAppHeader,
    TagAppHeaderOption,
    TagAvatar,
    TagBadge,
    TagBar,
    TagButton,
    TagCard,
    TagCardKpi,
    TagCardOkr,
    TagCardProfile,
    TagCarousel,
    TagCarouselSlide,
    TagChartGrid,
    TagCheckbox,
    TagCode,
    TagColour,
    TagColourOption,
    TagColourPicker,
    TagColumnPicker,
    TagCombobox,
    TagConfirm,
    TagDataBinder,
    TagDatePicker,
    TagEditField,
    TagEditFieldOption,
    TagEditList,
    TagField,
    TagFilePicker,
    TagForm,
    TagFormGroup,
    TagGraphQL,
    TagHttp,
    TagIcon,
    TagIconCustom,
    TagIconSvg,
    TagLayoutSidenav,
    TagLink,
    TagList,
    TagMainHeader,
    TagMenu,
    TagMenuItem,
    TagMessage,
    TagModal,
    TagModalOption,
    TagNav,
    TagNavSimple,
    TagNavSimpleGroup,
    TagNavSimpleItem,
    TagPager,
    TagPill,
    TagPills,
    TagPopover,
    TagProgressDonut,
    TagProgressIndeterminate,
    TagRecord,
    TagRecordNav,
    TagSearch,
    TagSearchbox,
    TagSlider,
    TagStat,
    TagStats,
    TagStatsData,
    TagSubmenu,
    TagTab,
    TagTabContent,
    TagTabHeader,
    TagTabHeaders,
    TagTable,
    TagTableColumn,
    TagTableColumnEditor,
    TagTabs,
    TagText,
    TagToast,
    TagToggle,
    TagTooltip,
    TagTopNavbar,
    TagValidation,
    TagValidationAlert,
    TagWizard,
    TagWizardStep,
    TagWizardVertical,
    TagWizardVerticalContent,
    TagWizardVerticalStep,
    TagWizardVerticalStepIndicator,
    TagWizardVerticalSteps
  ], opts);
}